import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({
    providedIn: 'root'
})
export class DoctoresService {

    constructor(
      private api: ApiService
    ) {}

    /* -------------------------------------------------------------------------- */
    /*                              BUSCAR PACIENTES                              */
    /* -------------------------------------------------------------------------- */
    buscarDoctor(_token, limit, ofset, paciente, tipoBusqueda) {
      return this.api.post<{
        rows: any[];
        pagination: { limit: number; offset: number; total: number };
      }>('/persons/doctors/list', {
        limit: Number(limit) || 10,
        offset: Number(ofset) || 0,
        search: paciente || 'vacio',
        searchType: tipoBusqueda || 'NombreVendedor'
      }).pipe(
        map((resp) => ({
          ...resp,
          total: resp.pagination.total
        }))
      );
    }

    /* -------------------------------------------------------------------------- */
    /*                           MOSTRAR DOCTORES NORMAL                          */
    /* -------------------------------------------------------------------------- */
    mostrarDoctoresNormal(_token,item, valor) {
      const field = String(item || '').trim();
      const value = String(valor || '').trim();

      if (!field || !value) {
        return of({ rows: [{}] });
      }

      return this.api.post<{ rows: any[] }>('/persons/doctors/search', {
        field,
        value
      }).pipe(
        catchError((error) => {
          if (Number(error?.status) === 400 || Number(error?.error?.statusCode) === 400) {
            return of({ rows: [{}] });
          }

          throw error;
        })
      );
    }


    /* -------------------------------------------------------------------------- */
    /*                             ESPECIALIDAD DOCTOR                            */
    /* -------------------------------------------------------------------------- */
    especialidadesDoctor(_token, _limit, _ofset, _paciente, _tipoBusqueda) {
      return this.api.post<{ rows: any[] }>('/persons/doctors/specialties');
    }


    /* -------------------------------------------------------------------------- */
    /*                               GUARDAR DOCTOR                               */
    /* -------------------------------------------------------------------------- */
    guardarDoctor(
      identificacionDoctor,
      nuevoNombreDoctor,
      nuevaFechaNDoctor,
      nuevoTelefonoDoctor,
      nuevoEmailDoctor,
      nuevaDireccionDoctor, 
      nuevoSexoDoctor,
      nuevaEdadDoctor,
      bancoDoctor,
      cuentaDoctor,
      talonarioDocotor,
      especialidaDoctor,
      token){


      return this.api.post('/persons/doctors/create', {
        identificacion: identificacionDoctor,
        nombre: nuevoNombreDoctor,
        fechaNacimiento: nuevaFechaNDoctor,
        telefono: nuevoTelefonoDoctor,
        email: nuevoEmailDoctor,
        direccion: nuevaDireccionDoctor,
        banco: bancoDoctor,
        numeroCuenta: cuentaDoctor,
        talonario: talonarioDocotor,
        especialidad: especialidaDoctor
      }).pipe(map(() => 'ok'));

    }

    /* -------------------------------------------------------------------------- */
    /*                            GUARDAR REQUERIMIENTO                           */
    /* -------------------------------------------------------------------------- */
    guardarRequerimiento(descripcion, codigoDoctor, token){

      return this.api.post('/persons/doctors/requests/orders', {
        doctor: codigoDoctor,
        descripcion
      }).pipe(map(() => 'ok'));

    }

    /* -------------------------------------------------------------------------- */
    /*                     GUARDAR REQUERIMIENTO CAPACITACION                     */
    /* -------------------------------------------------------------------------- */
    guardarRequerimientoCapacitacion(nuevoComentarioCapacitar, codigoDoctor,nuevaFechaCapacitar, servicios, token){

      return this.api.post('/persons/doctors/requests/training', {
        doctor: codigoDoctor,
        descripcion: nuevoComentarioCapacitar,
        fecha: nuevaFechaCapacitar,
        servicios
      }).pipe(map(() => 'ok'));

    }
  

    /* -------------------------------------------------------------------------- */
    /*                             ENVIAR NOTIFICACIO                             */
    /* -------------------------------------------------------------------------- */
    enviarNotificacion(descripcion, doctor, asesor, _token){
      return this.api.post('/transactions/requirements/advisor/notify', {
        advisorName: asesor,
        description: descripcion,
        doctorName: doctor
      }).pipe(map(() => 'ok'));
    }
  


        /* -------------------------------------------------------------------------- */
    /*                            GUARDAR REQUERIMIENTO                           */
    /* -------------------------------------------------------------------------- */
    enviarNotificacionDoctor(telefono, identificacionDoctor,token){

      return this.api.post('/persons/doctors/app-access/notify', {
        telefono,
        identificacionDoctor
      }).pipe(
        map(() => 'ok'),
        catchError(() => of('error'))
      );

    }


}
